import { createSelector } from "reselect";
import { STORES } from "../stores";
import { LanguageSlice } from "./language.types";

export const selectLanguageManager = (state: any): LanguageSlice =>
  state[STORES.LANGUAGE];

export const selectCurrentLanguage = (state: any) =>
  selectLanguageManager(state).languageId;
